import { BlogSection } from '@/types/blog';

export const introSection: BlogSection = {
  id: 'intro',
  title: '',
  content: `
    <p>
      Wir leben in einer Zeit des Informationsüberflusses, aber nicht zwangsläufig der Klarheit. 
      Das gilt nirgendwo mehr als in der Welt der Finanzen. Der Markt ist ein Dschungel aus Beratern, 
      Coaches, Maklern und Vermittlern. Alle versprechen Sicherheit und Rendite, doch im Lärm der Angebote 
      geht die entscheidende Frage oft unter:
    </p>
    
    <blockquote>
      „Welche Art von Gespräch muss ich jetzt führen, um meine eigene Souveränität über mein Geld zurückzugewinnen?"
    </blockquote>
    
    <p>
      Die Suche nach Unterstützung ist selten nur eine Suche nach dem richtigen Produkt. Es ist der Wunsch nach einem Raum, 
      in dem wir Unsicherheiten und Ziele offenlegen können, ohne sofort in eine Verkaufslogik gedrängt zu werden. Dieser 
      Artikel dient Ihnen als Orientierungshilfe, um das Spielfeld der Experten zu verstehen und den Partner zu finden, 
      der wirklich Ihren Interessen dient.
    </p>
    
    <div class="aeo-snippet my-10 py-8 px-6 border-l-4 border-primary/60 bg-muted/40 rounded-r-lg" data-speakable="definition">
      <p class="text-sm font-medium text-muted-foreground mb-2">Auf einen Blick</p>
      <p class="text-base italic leading-relaxed">
        Was macht ein Finanzcoach? Ein Finanzcoach ist ein neutraler Prozessbegleiter, der die finanzielle 
        Selbstentscheidungskompetenz fördert. Im Fokus stehen nicht Produkte, sondern der Mensch: das Erkennen 
        von Verhaltensmustern, das Auflösen von Geld-Glaubenssätzen und die Vorbereitung auf eine eigenständige 
        Finanzplanung im Einzelcoaching. Er liefert das psychologische Fundament, um Bank- oder 
        Versicherungsgesprächen auf Augenhöhe zu begegnen.
      </p>
    </div>
  `
};
